export const REQUEST_PENDING = "PENDING"
export const REQUEST_SUCCEEDED = "SUCCEEDED"
export const REQUEST_FAILED = "FAILED"